// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"79":"ad8a9a3fbc48e1d10bb1","258":"f47f9f88d988fc823b7b","310":"500d11146fae14ac18ee","926":"3b2ffea26e1251e3e8ae"}[chunkId] + ".chunk.js";
};